<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="bill-no-box" v-show="billNoBoxShow">
    {{inputBillNoStr}}
  </div>
  <van-steps :active="active">
    <van-step>选择驾驶员</van-step>
    <van-step>选择押运员</van-step>
    <van-step>选择车头</van-step>
    <van-step>选择车挂</van-step>
  </van-steps>

  <div class="chose-list" v-show="driverShow">
    <van-radio-group v-model="driverRadio" @change="changeDriver">
      <div v-if="driverList.length>0">

        <div v-for="(item, index)  in driverList" :key="index">
          <van-radio :name="index">
            <div class="chose-item">
              <div class="chose-item-content">
                <div class="chose-name">姓名:{{item.name}}</div>
                <div class="content-item">联系电话:{{item.telphone}}</div>
                <div class="content-item">身份证:{{item.shenfenzheng}}</div>
                <div class="content-item">驾驶证截至日期:{{item.jiashizhengyxq}}</div>
                <div class="content-item">从业资格证截至日期:{{item.congyezigeyxq}}</div>
              </div>
            </div>
          </van-radio>
        </div>
      </div>
      <div v-else>
        <van-empty image="error" description="请先新增驾驶员备案">
          <van-button round type="danger" class="bottom-button" :to="{name: 'driver'}">新增驾驶员备案</van-button>
        </van-empty>

      </div>
    </van-radio-group>
  </div>

  <div class="chose-list" v-show="escortShow">
    <van-radio-group v-model="escortRadio" @change="changeEscort">
      <van-notice-bar left-icon="volume-o" text="无押运员的普货车辆请到押运员界面录入司机信息" />
      <div v-if="escortList.length >0">
        <div v-for="(item, index)  in escortList" :key="index">
          <van-radio :name="index">
            <div class="chose-item">
              <div class="chose-item-content">
                <div class="chose-name">姓名:{{item.name}}</div>
                <div class="content-item">联系电话:{{item.telphone}}</div>
                <div class="content-item">身份证号:{{item.shenfenzheng}}</div>
                <div class="content-item">从业资格证截至日期:{{item.congyezigeyxq}}</div>
              </div>
            </div>
          </van-radio>
        </div>
      </div>
      <div v-else>
        <van-empty image="error" description="请先新增押运员备案,无押运员的普货车辆请到押运员界面录入司机信息" >
          <van-button round type="danger" class="bottom-button" :to="{name: 'escort'}">新增押运员备案</van-button>
        </van-empty>
      </div>
    </van-radio-group>
  </div>

  <div class="chose-list" v-show="chetouShow">
    <van-radio-group v-model="chetouRadio" @change="changeChetou">
      <div v-if="chetouList.length >0">
        <div v-for="(item, index) in chetouList" :key="index">
          <van-radio :name="index">
            <div class="chose-item">
              <div class="chose-item-content">
                <div class="chose-name">车头号:{{item.name}}</div>
              </div>
            </div>
          </van-radio>
        </div>
      </div>
      <div v-else>
        <van-empty image="error" description="请先新增车头备案" >
          <van-button round type="danger" class="bottom-button" :to="{ name: 'vehicle',params: {type: 0}}">新增车头备案</van-button>
        </van-empty>
      </div>
    </van-radio-group>
  </div>

  <div class="chose-list" v-show="cheguaShow">
    <van-radio-group v-model="cheguaRadio" @change="changeChagua">
      <div v-if="cheguaList.length >0">
        <div v-for="(item, index) in cheguaList" :key="index">
          <van-radio :name="index">
            <div class="chose-item">
              <div class="chose-item-content">
                <div class="chose-name">车挂号:{{item.name}}</div>
              </div>
            </div>
          </van-radio>
        </div>
      </div>
      <div v-else>
        <van-empty image="error" description="请先新增车挂备案">
          <van-button round type="danger" class="bottom-button" :to="{ name: 'vehicle',params: {type: 1}}">新增车挂备案</van-button>
        </van-empty>
      </div>
    </van-radio-group>
  </div>

  <div class="step-box">
    <div class="before-step" v-show="beforeShow">
      <van-button round block type="primary" @click="beforeStep" class="beforeBtn">
        上一步
      </van-button>
    </div>
    <div class="after-step" v-show="afterShow">
      <van-button round block type="info" @click="afterStep" class="afterBtn" :disabled="afterDisabled">
        下一步
      </van-button>
    </div>

    <div class="after-step" v-show="finishShow">
      <van-button round block type="info" @click="finishStep" class="afterBtn" :disabled="finishDisabled">
        完成
      </van-button>
    </div>
  </div>

  <van-dialog v-model="inputShow" show-cancel-button @confirm="confirmBillNo" @cancel="cancelBillNo" @closed="closedBillNo">
    <div class="input-show-title">{{inputShowTitle}} </div>
    <div class="input-show-title input-show-exntend">(如不清楚请与客户联系)</div>
    <van-field v-model="inputBillNo" input-align="center" :placeholder="inputPlaceHolder"/>
  </van-dialog>

</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Dialog,
  Toast,

} from 'vant';
export default {
  data() {
    return {
      navTitle: (this.$route.params.type == 'tihuo') ? "预约提货" : "预约卸货",
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      driverRadio: 0,
      escortRadio: 0,
      chetouRadio: 0,
      cheguaRadio: 0,
      active: 0,
      driverShow: true,
      escortShow: false,
      chetouShow: false,
      cheguaShow: false,
      beforeShow: false,
      afterShow: false,
      finishShow: false,
      afterDisabled: true,
      finishDisabled: true,
      choseDriverList: [],
      choseEscortList: [],
      choseChetouList: [],
      choseCheguaList: [],
      driverList: [],
      escortList: [],
      chetouList: [],
      cheguaList: [],
      type: "tihuo",
      cheguahao: "",
      chetouhao: "",
      driverNo: "",
      escortNo: "",
      driverName: "",
      escortName: "",
      inputShow:false,
      inputShowTitle:"",
      inputBillNo:"",
      billNoBoxShow:false,
      inputBillNoStr:"",
      isCancelBillNo:false,
      inputPlaceHolder:"",
    }
  },

  created() {
    var that = this;
    var openid = that.$store.state.wx_info.openid;
    var type = that.$route.params.type;
    that.type = type ? type : "tihuo";
    document.title = (type == 'tihuo') ? "预约提货" : "预约卸货";
    that.inputShowTitle = (type == 'tihuo') ? "请先输入预约“提货单号”" : "请先输入预约“卸货单号”";
    that.inputPlaceHolder = (type == 'tihuo') ? "请先输入预约“提货单号”" : "请先输入预约“卸货单号”";
    that.getYuyueChose(openid, 'yyyxx');
    that.getYuyueChose(openid, 'cheguaxx');
  },
  mounted()
  {
    var openid = this.$store.state.wx_info.openid;
    this.$nextTick(function() {
      // 仅在整个视图都被渲染之后才会运行的代码
  this.getYuyueChose(openid, 'jsyxx');
  this.getYuyueChose(openid, 'chetouxx');
    })
  },
  methods: {
    getYuyueChose(openid, leibie) {
      var that = this;
      api.getYuyueChose(openid, leibie).then(function(res) {

        var resData = JSON.parse(res);
        if (resData.respCode == "0") {

          switch (leibie) {
            case 'jsyxx':
              that.$data.driverList = resData.data;
              var driverList = that.$data.driverList;
              //that.$data.driverList = [];
              //var driverList = [];
              if (driverList.length > 0) {
                that.inputShow = true;
                var driverRadio = that.driverRadio;
                that.$data.driverNo = driverList[driverRadio].shenfenzheng;
                that.$data.driverName = driverList[driverRadio].name;
                that.afterShow = true;
                that.afterDisabled = false;
              }
              else
              {
                that.inputShow = true;
              }

              break;
            case 'yyyxx':
              that.$data.escortList = resData.data
              var escortList = that.$data.escortList;
              if (escortList.length > 0) {
                var escortRadio = that.escortRadio;
                that.$data.escortNo = escortList[escortRadio].shenfenzheng;
                that.$data.escortName = escortList[escortRadio].name;
                that.afterShow = true;
              }
              break;
            case 'chetouxx':
              that.$data.chetouList = resData.data
              var chetouList = that.$data.chetouList;
              if (chetouList.length > 0) {
                var chetouRadio = that.chetouRadio;
                that.$data.chetouhao = chetouList[chetouRadio].name;
                that.afterShow = true;
              }
              break;
            case 'cheguaxx':
              that.$data.cheguaList = resData.data
              var cheguaList = that.$data.cheguaList;

              if (cheguaList.length > 0) {
                var cheguaRadio = that.cheguaRadio;
                that.$data.cheguahao = cheguaList[cheguaRadio].name;
                that.afterShow = true;
                that.finishDisabled = false;
              } else {
                that.finishDisabled = true;
              }

              break;
          }
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function() {
        //console.log(err);
        //Toast.fail('连接失败，请刷新页面');
      });
    },
    changeDriver(index) {
      var driverList = this.$data.driverList;
      this.driverNo = driverList[index].shenfenzheng;
      this.driverName = driverList[index].name;
    },
    changeEscort(index) {
      var escortList = this.$data.escortList;
      this.escortNo = escortList[index].shenfenzheng;
      this.escortName = escortList[index].name;
    },
    changeChetou(index) {
      var chetouList = this.$data.chetouList;
      this.chetouhao = chetouList[index].name;
    },
    changeChagua(index) {
      var cheguaList = this.$data.cheguaList;
      this.cheguahao = cheguaList[index].name;
    },
    beforeStep() {
      this.active = this.active - 1;
      this.afterDisabled = false;
    },
    afterStep() {
      this.active = this.active + 1;
      var active = this.active;
      //var openid = this.$store.state.wx_info.openid;

      switch (active) {
        case 1:
          this.afterDisabled = (this.escortList.length == 0) ? true : false;
          break;
        case 2:
          this.afterDisabled = (this.chetouList.length == 0) ? true : false;
          break;
        case 3:
          this.afterDisabled = (this.cheguaList.length == 0) ? true : false;
          this.finishDisabled = (this.cheguaList.length == 0) ? true : false;
          break;
      }

    },
    finishStep() {
      var inputBillNo = this.inputBillNo.replace(/[\s]+/g, '').trim().replace(/[\r\n]+/g, '');
      this.inputBillNo = inputBillNo;

      var chetouhao = this.chetouhao;
      var cheguahao = this.cheguahao;
      var driverNo = this.driverNo;
      var escortNo = this.escortNo;
      var driverName = this.driverName;
      var escortName = this.escortName;
      var type = this.type;

      if ( !cheguahao || !cheguahao || !driverNo || !escortNo) {
        switch (true) {
          case (!inputBillNo):
            Toast.fail("请输入单号");
            break;
            case (!driverNo):
            Toast.fail('请先选择驾驶员');
            break;
            case (!escortNo):
            Toast.fail('请先选择押运员');
            break;
            case (!chetouhao):
            Toast.fail('请先选择车头号');
            break;
            case (!cheguahao):
            Toast.fail('请先选择车挂号');
            break;
        }
      } else {
        Dialog.confirm({
          message: '车头号：'+chetouhao+'，\n车挂号：'+cheguahao+'，\n驾驶员：'+driverName+' '+driverNo+'，\n押运员：'+escortName+' '+escortNo+'，\n是否确认使用上述车辆及驾押人员进行预约？',
        })
            .then(() => {
              if (type == 'xiehuo') {
                this.$router.push({
                  name: 'appointmentXh',
                  params: {
                    inputBillNo:inputBillNo,
                    chetouhao: chetouhao,
                    cheguahao: cheguahao,
                    driverNo: driverNo,
                    escortNo: escortNo,
                  }
                })
              } else {
                this.$router.push({
                  name: 'appointmentTh',
                  params: {
                    inputBillNo:inputBillNo,
                    chetouhao: this.chetouhao,
                    cheguahao: this.cheguahao,
                    driverNo: this.driverNo,
                    escortNo: this.escortNo,
                  }
                })
              }
            })
            .catch(() => {
              // on cancel
            });

      }
    },
    confirmBillNo()
    {
      var inputBillNo = this.inputBillNo.replace(/[\s]+/g, '').trim().replace(/[\r\n]+/g, '');
      this.inputBillNo = inputBillNo;

      if(inputBillNo.length >0)
      {
        var type = (this.type == "tihuo")?"提货":"卸货";
        this.inputBillNoStr = "预约"+type+"单号:"+inputBillNo;
        this.billNoBoxShow = true;
      }
    },
    cancelBillNo()
    {
      this.isCancelBillNo = true;
      this.$router.push({
        name: 'index'
      });
    },
    closedBillNo()
    {
      if(this.inputBillNo.length <=0 && this.isCancelBillNo == false)
      {
        var type = (this.type == "tihuo")?"提货":"卸货";
        Dialog.alert({
          message: '请输入预约'+type+'单号',
        }).then(() => {
          // on close
          this.inputShow = true;
        });
      }
    },
  },
  watch: {
    active: {
      handler(val ) {//oldValue
        switch (val) {
          case 0:
            this.beforeShow = false;
            this.afterShow = true;
            this.finishShow = false;
            this.driverShow = true;
            this.escortShow = false;
            this.chetouShow = false;
            this.cheguaShow = false;
            if (!this.$data.driverNo) {
              this.afterShow = false;
            }

            break;
          case 1:
            this.beforeShow = true;
            this.afterShow = true;
            this.finishShow = false;

            this.driverShow = false;
            this.escortShow = true;
            this.chetouShow = false;
            this.cheguaShow = false;
            break;
          case 2:
            this.beforeShow = true;
            this.afterShow = true;
            this.finishShow = false;

            this.driverShow = false;
            this.escortShow = false;
            this.chetouShow = true;
            this.cheguaShow = false;
            break;
          case 3:
            this.beforeShow = true;
            this.afterShow = false;
            this.finishShow = true;

            this.driverShow = false;
            this.escortShow = false;
            this.chetouShow = false;
            this.cheguaShow = true;
            break;
        }
      },
      deep: true //true 深度监听
    }
  }
}
</script>
<style lang="scss" scoped>
.chose-list {

    .chose-item {
        margin: 1rem 0;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .chose-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 4.2rem;
            line-height: 2.1rem;
            padding: 0.625rem 1rem;
            color: #323233;
            .chose-name {
                //margin-bottom: 10px;
                font-weight: bold;
                font-size: .875rem;
                line-height:3;
            }
            .content-item {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .chose-item-desc {
            padding: 0.25rem 0.5rem;
            font-size: .875rem;
            border-top: 0.03rem dashed #ebedf0;
        }
    }
}

.van-radio {
    margin-left: 1rem;
}

.step-box {
    position: fixed;
    bottom: 1rem;
    width: 100%;
    .before-step {
        display: inline-block;
        width: 50%;
        float: left;
        .beforeBtn {
            width: 80%;
            margin: 0 auto;
        }
    }

    .after-step {
        display: inline-block;
        width: 50%;
        float: right;
        .afterBtn {
            width: 80%;
            margin: 0 auto;
        }
    }
}

.bill-no-box{
  background: #fff;
  font-size: 1rem;
  padding: 1rem .5rem;
  color: #1989fa;
}

.input-show-title{
  padding:26px 10px 0 10px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
}

.input-show-exntend{
  padding-top: 0;
}
</style>
